const constraints = {
  year: {
    presence: {
      allowEmpty: false,
      message: 'Required',
    }
  },
  make: {
    presence: {
      allowEmpty: false,
      message: 'is Required',
    },
  },
  model: {
    presence: {
      allowEmpty: false,
      message: 'is Required',
    },
  },
  mileage: {
    presence: {
      allowEmpty: false,
      message: '^Required',
    },
  },
};

export default constraints;
